/**
 * Clear all Zustand persisted stores from localStorage on logout.
 *
 * Prevents user data leaking between sessions when a different user
 * logs in on the same browser.
 */

// All Zustand persist storage keys used across the app.
// When adding a new persisted store, add its storage key here.
const PERSISTED_STORE_KEYS = [
  "auth-storage",
  "sigmavue-ai-chat-session",
  "notification-store",
  "tutorial-state",
  "sigmavue-donna-admin-session",
  // FE-1 item 5: Donna support-chat thread cache (donna-chat.store.ts) —
  // must never survive into another user's session on the same browser.
  "sigmavue-donna-chat",
  "sigmavue-active-account",
  "help-storage",
  "chart-settings-storage",
  "perminance-storage",
  "profile-store",
  "unified-profile-store",
  "sidebar-storage",
  "trading-profile-store",
  "misc-storage",
  "sv-subscription",
  "strategy-store",
  "user-preferences-storage",
  "tradovate-auth-storage",
  "component-flags-storage",
  "feature-flags-storage",
  "chart-drawings",
  "sigmavue-strategy-store",
] as const;

/**
 * Remove all persisted Zustand store data from localStorage.
 * Call this during signOut to prevent data leaking to the next user session.
 */
export function clearAllStores(): void {
  if (typeof window === "undefined") return;

  for (const key of PERSISTED_STORE_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // localStorage may be unavailable (e.g. private browsing quota exceeded)
    }
  }
}
